import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { RenameKeyService } from '@segurosvoluntarios_vel/commons-services';
import { OptionInput } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-form';
import { FormPago } from 'src/app/pago/enums/FormPago.enum';
import { MapKeyOption } from 'src/app/pago/enums/MapKeyOption.enum';
import { TipoIdentificacion } from 'src/app/pago/enums/TipoIdentificacion.enum';
import { Ciudad } from 'src/app/pago/models/Ciudad.model';
import { Maestro } from 'src/app/pago/models/Maestro.model';

@Component({
  selector: 'app-form-datos-otra-persona',
  templateUrl: './form-datos-otra-persona.component.html',
  styleUrls: ['./form-datos-otra-persona.component.scss'],
})
export class FormDatosOtraPersonaComponent implements OnInit {
  @Input() otraPersonaFormGroup: FormGroup;
  @Input() submitted: boolean;
  @Input() tiposDocumento: Maestro[];
  @Input() ciudades: Ciudad[];
  @Output() handleFormatDireccion: EventEmitter<any> = new EventEmitter();
  maxLengthNumeroIdentificacion = 10;

  ngOnInit(): void {
    this.otraPersonaFormGroup.get(FormPago.DIRECCION).disable();
    this.otraPersonaFormGroup.get(FormPago.RAZON_SOCIAL).disable();
  }

  get controlTipoIdentificacion(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.TIPO_DOCUMENTO);
  }

  get controlNumeroIdentificacion(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.NUMERO_DOCUMENTO);
  }

  get controlNombres(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.NOMBRES);
  }

  get controlApellidos(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.APELLIDOS);
  }

  get controlRazonSocial(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.RAZON_SOCIAL);
  }

  get controlCorreo(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.CORREO);
  }

  get controlCiudad(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.CIUDAD);
  }

  get controlTelefono(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.TELEFONO);
  }

  get controlDireccion(): AbstractControl {
    return this.otraPersonaFormGroup.get(FormPago.DIRECCION);
  }

  getTipoDocumentoOptions(tiposDocumento: Maestro[]): OptionInput[] {
    return RenameKeyService.replaceKeyByMap(
      {
        codigo: MapKeyOption.VALUE,
        valor: MapKeyOption.NAME,
      },
      tiposDocumento
    );
  }

  handleChangeCiudad(event: NgbTypeaheadSelectItemEvent | null) {
    if (!event) {
      this.controlDireccion.disable();
    } else {
      this.controlDireccion.enable();
    }
  }

  handleChangeTipoDocumento(tipoIdentificacion: string) {
    switch (tipoIdentificacion) {
      case TipoIdentificacion.NIT:
        this.controlNombres.disable();
        this.controlApellidos.disable();
        this.controlRazonSocial.enable();
        this.controlRazonSocial.setValidators([Validators.required]);
        break;
      case TipoIdentificacion.PASAPORTE:
        this.maxLengthNumeroIdentificacion = 11;
        break;
      default:
        this.maxLengthNumeroIdentificacion = 10;
        this.controlNombres.enable();
        this.controlApellidos.enable();
        this.controlRazonSocial.disable();
        this.controlRazonSocial.clearValidators();
        break;
    }
  }

  handleChangeDireccion() {
    this.handleFormatDireccion.emit();
  }
}
